import { ComponentType } from 'react'

import { type NodeProps, type NodeTypes } from '@xyflow/react'

import { FlowNode } from './FlowNode'
import { NodeUI, NodeUIType } from './types'

const buildNodeComponent = (type: NodeUIType) => {
  const NodeComponent = (props: NodeProps<NodeUI>) => {
    return <FlowNode {...props} />
  }
  NodeComponent.displayName = `${type}Node`
  return NodeComponent
}

export const nodeTypes: NodeTypes = {
  trigger: buildNodeComponent('trigger'),
  condition: buildNodeComponent('condition'),
  conditionIf: buildNodeComponent('conditionIf'),
  conditionElse: buildNodeComponent('conditionElse'),
  // notification: buildNodeComponent('notification'),
  approvals: buildNodeComponent('approvals'),
  task: buildNodeComponent('task'),
} satisfies Record<NodeUIType, ComponentType<NodeProps<NodeUI>>>
